import { Component, OnInit } from '@angular/core';
import Swal from 'sweetalert2';
import { ProjectManagementService } from '../project-management.service';

@Component({
  selector: 'app-project-analytics',
  templateUrl: './project-analytics.component.html',
  styleUrls: ['./project-analytics.component.scss']
})
export class ProjectAnalyticsComponent implements OnInit {
  loading = false;
  analytics: any = null;
  projects: any[] = [];

  constructor(private projectService: ProjectManagementService) {}

  ngOnInit(): void {
    this.refresh();
  }

  refresh(): void {
    this.loading = true;
    this.projectService.getProjectAnalytics().subscribe({
      next: (analytics) => {
        this.analytics = analytics || null;
        this.loadProjects();
      },
      error: (err) => {
        this.loading = false;
        Swal.fire('Error', err?.error?.message || 'Failed to load project analytics.', 'error');
      }
    });
  }

  loadProjects(): void {
    this.projectService.getProjects().subscribe({
      next: (projects) => {
        this.projects = (projects || []).sort((a: any, b: any) => Number(b.progressPercent || 0) - Number(a.progressPercent || 0));
        this.loading = false;
      },
      error: () => {
        this.projects = [];
        this.loading = false;
      }
    });
  }

  get completionRate(): number {
    if (!this.analytics?.totalTasks) return 0;
    return Math.round((Number(this.analytics.completedTasks || 0) / Number(this.analytics.totalTasks || 1)) * 100);
  }
}
